import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useNavigate, useParams } from "react-router-dom";
import getTimeDifference from "../../../../Common/TimeDifference";
import { formatNumberWithCommas, getPosttype } from "../../../../Common/AllDateTimeReleventFormate";
import DownloadwithDisplayProper from "../../../../Common/FilesRelevent/DownloadwithDisplayProper";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import GetPrice from "../../../MyOrders/MyOrders/PostedOrders/PostedProjects/MineActiveProject/ProjectModels/GetPrice";
import { useRouteBaseStateContext } from "../../../../../Context/RouteBaseStateContext";
import { useDispatch } from "react-redux";
import { DeclineContractProposal } from "../../../../../redux/job/action";
import CustomeCategoryandSubcategory from "../../../../Common/CustomeLabel/CustomeCategoryandSubcategory";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import DeadlineComponents from "../../../../Common/DeadlineComponents";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";

export default function ManageAppliedProjectProposal({ posts, pd }) {
  const { setManageAppliedjobroute } = useRouteBaseStateContext();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [loading, setLoading] = useState(false);
  const path = "Assets/scss/FindWork.module.scss";

  const dispatch = useDispatch();

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const navigate = useNavigate();

  const hitthismethod1 = () => {
    setManageAppliedjobroute("JobDetails");
    window.location.reload();
  };

  const DeclineContract = () => {
    const data = {
      type: "3",
      id: pd?.id,
      status: "24",
    };
    dispatch(DeclineContractProposal(data, setLoading, hitthismethod1));
  };

  return (
    <div className="project-offer project-details ">
      {(pd?.status == 23 || pd?.status == 24 || pd?.status == 25) ? (
        <div className="post-details">
          {
            pd?.status == 24 ?
              <h2>Declined, your offer has been Declined</h2> :
              <h2>Congratulation 🎉, You received an offer</h2>
          }
          <div className="filter-detail">
            <div>
              <h5>
                {posts.title} <span className="job">{getPosttype(posts.type)}</span>
              </h5>
              <div className="dollar-sec">
                <p>
                  {/* <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/dollar.svg`}
                  alt=""
                /> */}
                  <GetPrice
                    type={posts?.type}
                    price={pd?.price}
                    hiring_type={posts?.hiring_type}
                  />
                </p>
                {posts?.type == 3 ? (
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/dashboard/job-type.svg`}
                      alt=""
                    />
                    Job type:
                    {posts?.work_location == 1
                      ? "Virtual"
                      : posts?.work_location == 2
                        ? "Physical"
                        : ""}
                  </p>
                ) : (
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                      alt=""
                    />
                    <DeadlineComponents posts={posts} />
                  </p>
                )}
                <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/message.svg`}
                    alt=""
                  />
                  Posted:{getTimeDifference(posts?.created_on)}
                </p>
              </div>
              <CustomeCategoryandSubcategory posts={posts} />
              <div className="lang-sec">
                <h6>Description</h6>
                <CustomReactQuillDescription value={posts?.description} />
              </div>
              <div className="lang-sec">
                <h6>Competencies</h6>
                <div className="photoshop">
                  {Array.isArray(pd?.skills) &&
                    pd?.skills.map((item1, index1) => (
                      <p key={index1}>{item1.title}</p>
                    ))}
                </div>
              </div>
              <div className="lang-sec">
                {Array.isArray(pd?.files) &&
                  pd?.files &&
                  pd?.files?.length > 0 && (
                    <div className="lang-sec">
                      <h6>Attachments</h6>
                      <div className="images">
                        {pd?.files &&
                          Array.isArray(pd?.files) &&
                          pd?.files.map((item, index) => {
                            return <DownloadwithDisplayProper item={item} />;
                          })}
                      </div>
                    </div>
                  )}
              </div>

              {/* <div className ="photoshop">
                {Array.isArray(posts?.skills) &&
                  posts?.skills.map((item1, index1) => (
                    <p key={index1}>{item1.title}</p>
                  ))}
              </div> */}
              <div className="proposal pt-3">
                {(Number(posts.price2) !== 0) && <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/proposal.svg`}
                    alt=""
                  />
                  {posts?.type == 2 ? "Entries" : "Proposal"}:
                  {posts.proposal_count}
                </p>}
                {posts?.type == 3 ? (
                  <p>
                    <img
                      src={`${CloudStorage.cloudurl}/Assets/Images/project/location.svg`}
                      alt=""
                    />
                    Location : {posts.city_name}
                  </p>
                ) : (
                  ""
                )}
                <p>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/project/payment.svg`}
                    alt=""
                  />
                  Verified Payment
                </p>
              </div>
            </div>
            {/* <button className ="btn heart-btn" onClick={() => navigate(`/${lan}/projectdetails/${posts.id}`)}>
            {posts.wishlist == 1 ? <img src={`${CloudStorage.cloudurl}/Assets/Images/project/heart-active.svg`} alt="" /> : <img src={`${CloudStorage.cloudurl}/Assets/Images/project/heart.svg`} alt="" />}
          </button> */}
          </div>
          {/* {Array.isArray(posts?.files) &&
            posts?.files &&
            posts?.files?.length > 0 && (
              <div className ="lang-sec">
                <h6>Attachments</h6>
                <div className ="images">
                  {posts?.files &&
                    Array.isArray(posts?.files) &&
                    posts?.files.map((item, index) => {
                      return <DownloadwithDisplayProper item={item} />;
                    })}
                </div>
              </div>
            )} */}
          {
            (pd?.status == 23) ?

              <div className="submit-btn">
                <button
                  disabled={loading || pd?.status == 25}
                  onClick={() => DeclineContract()}
                  className="btn"
                >
                  {loading ? <LoginLoaderButton /> : "Decline offer"}
                </button>
                <button
                  disabled={loading || pd?.status == 25}
                  className="btn post-btn"
                  onClick={() =>
                    navigate(`/${lan}/jobcontract/${pd.id}`, {
                      state: { approvefrom: "user", type: "job" },
                    })
                  }
                >
                  Accept offer
                </button>
              </div>
              :
              (pd?.status == 24) ?
                <div className="submit-btn">
                  <button
                    // onClick={() => DeclineContract()}
                    className="btn"
                    disabled
                  >
                    Declined
                  </button>

                </div> : <></>
          }
        </div>
      ) :
        <PostNotFound title="No offer yet" height={200} />
      }
    </div>
  );
}
